import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

const PURPLE = "#A100FF";

export const MetricsMainWrapper = styled(Box)({
  width: "100%",
  background: "#ffffff"
});

export const BannerSection = styled(Box)({
  width: "100%",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "260px",
});

export const BannerContent = styled(Box)({
  padding: "105px 5%",
  width: "70%",
});

export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "32px",
  fontWeight: 600,
  fontFamily: "Graphik",
  lineHeight: "100%",
  letterSpacing: 0,
});

export const MetricsBody = styled(Box)({
  padding: "32px 5% 64px",
});

export const FilterWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "24px",
});

export const FilterButton = styled(Button)({
  height: "32px",
  padding: "0 10px 0 12px",
  fontSize: "12px",
  textTransform: "none",
  borderColor: "#E5E7EB",
  color: "#000",
  display: "flex",
  alignItems: "center",
  gap: "40px",
  minWidth: "96px",
  borderRadius: "0px",
});

export const FilterIcon = styled("img")({
  width: "14px",
  height: "14px",
  opacity: 0.9,
});

export const MetricsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "24px",
});

export const MetricCard = styled(Box)({
  height: "96px",
  border: "1px solid #CFCFCF",
  borderRadius: "0px",
  padding: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#FFFFFF",
  boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
});

export const MetricValue = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: "#7500C0",
  lineHeight: 1.2,
  fontFamily: "Graphik",
});

export const MetricLabel = styled(Typography)({
  fontSize: "16px",
  color: "#000000",
  fontFamily: "Graphik",
  fontWeight: "400",
  lineHeight: "28px"
});

export const MetricIcon = styled("img")({
  height: "40px",
});
